import { render } from "./EditJob.vue?vue&type=template&id=1b485457"
import script from "./EditJob.vue?vue&type=script&lang=js"
export * from "./EditJob.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__